export const SanitizedUrlKeys = ["action"];
export const OneDayInMilliseconds = 24 * 60 * 60 * 1000;
